import script from "./jijia-list.vue?vue&type=script&setup=true&lang=ts"
export * from "./jijia-list.vue?vue&type=script&setup=true&lang=ts"

import "./jijia-list.vue?vue&type=style&index=0&id=22e5935e&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22e5935e"]])

export default __exports__